import { Directive, HostListener} from '@angular/core';

@Directive({
  selector: '[igoStopDropPropagation]'
})
export class StopDropPropagationDirective {

  @HostListener('drop', ['$event'])
  public onDrop(event: any): void {
    event.preventDefault();
    event.stopPropagation();
  }

}



// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/lib/shared/stop-propagation/stop-drop-propagation.directive.ts